import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService, MainConfig } from "@atenea-cms";

@Component({
  selector: "product-video-form",
  templateUrl: "./product-video-form.component.html",
  styleUrls: ["./product-video-form.component.scss"],
})
export class ProductVideoFormComponent {
  @Input() form: FormGroup;

  config: any = {};

  constructor(public ft: FormToolsService, public mainConfig: MainConfig) {
    this.config = this.mainConfig.modules;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-video-form/product-video-form.component.ts